import { render, staticRenderFns } from "./ProductListDeleteConfirmModal.vue?vue&type=template&id=4d937262"
import script from "./ProductListDeleteConfirmModal.vue?vue&type=script&lang=js"
export * from "./ProductListDeleteConfirmModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports